import { useState, useEffect, useCallback, useMemo } from "react";
import { Stack } from "@mui/material";
import AdminUsersGrid from "../../components/admin/AdminUsersGrid";
import { apiFetch } from "../../api/apiFetch";
import { useAuth } from "../../context/AuthContext";
import { buildGridStateStorageKey } from "../../utils/gridStatePersistence";

const API_URL = process.env.REACT_APP_API_URL;

export default function AdminUsersPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const gridStorageKey = useMemo(
    () =>
      buildGridStateStorageKey({
        table: "admin-users",
      }),
    []
  );

  const loadUsers = useCallback(async () => {
    if (!user || user.role !== "admin") {
      setRows([]);
      return;
    }

    setLoading(true);

    try {
      const res = await apiFetch(`${API_URL}/users`);

      if (!res.ok) {
        throw new Error(`Failed to load users: ${res.status}`);
      }

      const data = await res.json();

      const normalized = Array.isArray(data)
        ? data.map((row: any) => ({
            ...row,
            id: row.id,

            companies_count:
              row.companies?.length ??
              row.companies_count ??
              row.company_admin_count ??
              0,
          }))
        : [];

      setRows(normalized);
    } catch (err) {
      console.error("Failed to load users", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;

    loadUsers();
  }, [user, loadUsers]);

  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <AdminUsersGrid
        gridStorageKey={gridStorageKey}
        rows={rows}
        loading={loading}
        total={rows.length}
        onUsersChanged={loadUsers}
      />
    </Stack>
  );
}